module.exports = __webpack_public_path__ + "img/04.785ea41f.png";